import React, { Component } from 'react'
import { connect } from 'react-redux'

import { 
    saveItem,
    openModal,
    createFiles,
    updateFile,
    updateFileParent
} from 'state/actions'

import FileDisplay from 'components/file/file-display'

import withValidateResponse from 'components/validations/withValidateResponse'

import EditableInputField from 'components/input/editableInputField'
import MainHeaderNav from 'sections/main-header-nav'

import FileInfo from 'sections/projects/project/project-files/tabs/file-info'
import FileVersions from 'sections/projects/project/project-files/tabs/file-versions'

import {
    getCurrentUser
} from 'state/selectors'

import {
    stripHtml
} from 'utils'

class ModalFileInfo extends Component {
    constructor(props){
        super(props)

        const {
            data,
            allFiles
        } = this.props

        this.state = {
            isNameBeingEdited: false,
            currentTab: 0,
            file: {
                ...data.file
            }
        }
    }

    UNSAFE_componentWillUpdate = nextProps => {
        const { file } = this.state

        const originalFile = this.props.allFiles[file.id]
        const nextOriginalFile = nextProps.allFiles[originalFile.id]

        if(originalFile && nextOriginalFile && nextOriginalFile.task_id !== originalFile.task_id){
            this.setState({
                file: {
                    ...nextOriginalFile
                },
            })
        }
    }

	handleSave = _ => {
        const {
			file
		} = this.state

		const {
            updateFile,
            data
		} = this.props

		if(file.name){
			let valueToSave = stripHtml(file.name)

			if(!valueToSave){
				return 
			}

			const updatedFile = {
                ...data.file,
				...file,
				name: valueToSave
			}

			updateFile(updatedFile)

			setTimeout(_ => {
				this.setState({
					isNameBeingEdited: false,
					file: updatedFile
				})
			},1)
		}
    }
    
    changeTab = tab => {
        this.setState({
            currentTab: tab.index
        })
    }

	deleteFile = _ => {
		const {
			openModal,
        } = this.props
        
        const {
            file
        } = this.state

		openModal('delete', 'file', { data: file })
    }
    
	updateParentTask = value => {
        const {
            updateFileParent,
            data
        } = this.props

		updateFileParent(data.file, value)
	}

    editFile = isNameBeingEdited => {
        this.setState({
            isNameBeingEdited,
            file: {
                ...this.state.file,
                name: isNameBeingEdited ? this.state.file.name : this.props.data.file.name
            }
        })
    }

    updateStateFile = (value, key) => {
        let newValue = value

		if(key == 'name'){
			newValue = newValue.replace(/(\r\n|\n|\r)/gm,"");
        }
        
        this.setState({
            file: {
                ...this.state.file,
                [key]: value
            }
        })
    }

    getFileUser = _ => {
        const {
            file,
        } = this.state

        const {
            allUsers
        } = this.props

        let user = null

        if(file && file.latestVersion){
            user = allUsers[file.latestVersion.user_id]
        }

        return user
    }

	render() {
        const {
            file,
            isNameBeingEdited,
            currentTab
        } = this.state

        const {
            allTasks,
            allProjects,
            createFiles,
            openModal
        } = this.props

        this.navTabs = [
            {
                name: 'Info',
                isActive: !currentTab,
                index: 0
            },{
                name: 'Version history',
                isActive: !!currentTab,
                index: 1
            }
        ]

        let currentProject = null

        if(file.project_id){
            currentProject = allProjects[file.project_id]
        }

		return(
			<div className="has-tabs">
                <div className="modal-tabs-heading">
                    <h2>
                        File info
                    </h2>
                    <MainHeaderNav 
                        right={true} 
                        callback={this.changeTab} 
                        navtabs={this.navTabs} 
                        type="settings-tabs" 
                    />
                </div>
                <div className="left">
                    <FileDisplay animateOnRender={true} file={file.latestVersion} />
					<EditableInputField 
						text={file.name} 
						updateText={value => {this.updateStateFile(value, 'name')}} 
						isEditing={isNameBeingEdited} 
						toggleEditing={_ => {this.editFile(true)}} 
						cancelEditing={_ => {this.editFile(false)}}
						id={file.id}
						ref={ref => {this.nameInput = ref}}
						canDelete={false}
						saveItem={_ => {this.handleSave('name')}}
					/>
                </div>
                <div className="right">
                    { !currentTab ?
                        <FileInfo 
                            allTasks={allTasks} 
                            currentProject={currentProject} 
                            file={file} 
                            user={this.getFileUser()}
                            openModal={openModal} 
                            deleteFile={this.deleteFile} 
                            updateParentTask={this.updateParentTask} 
                        />
                    :
                        <FileVersions 
                            createFiles={createFiles} 
                            file={file} 
                            openModal={openModal} 
                        />
                    }
                </div>
			</div>
		);
	}
}

const ModalFileInfoWithValidateResponse = withValidateResponse(ModalFileInfo)

const mapStateToProps = state => {
    return {
        allFiles: state.account.entities.files,
        allTasks: state.account.entities.tasks,
        allProjects: state.account.entities.projects,
        allUsers: state.account.entities.users,
        userData: getCurrentUser(state),
    }
}

export default connect(mapStateToProps, {
    saveItem,
    openModal,
    createFiles,
    updateFile,
    updateFileParent
})(ModalFileInfoWithValidateResponse)
